<template>
  <div class="container-fluid">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">
                <span class="title">Bem Vindo(a) {{ this.currentUser.usuario.nome }}</span>
              </h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          <h5 class="panel-title">
            <span class="title">Conceda acesso aos seus respectivos responsáveis.</span>
          </h5>
          <div class="row">
            <DataTable :value="usuarioAcessoList" :paginator="true" :rows="10" :autoLayout="true" :filters="filtersModel">
              <template #header>
                <div style="line-height:1.87em" class="p-clearfix">Lista de Usuários com acesso.</div>
              </template>
              <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Remover?">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-trash"
                    @click="confirmRemove(slotProps.data.idUsuario, slotProps.data.idContribuinte)"></Button>
                </template>
              </Column>
              <Column headerStyle="width: 8em" bodyStyle="text-align: center" header="Permissões">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-cog"
                    @click="showPermissoes(slotProps.data.idUsuario, slotProps.data.idContribuinte)"></Button>
                </template>
              </Column>
              <Column headerStyle="width: 18em" bodyStyle="text-align: center" header="Master"
                v-if="this.currentUser.usuario.idBolAdmin">
                <template #body="slotProps">
                  <Button type="button" icon="pi pi-check" label="Definir como Usuário Master"
                    v-if="!slotProps.data.master" @click="saveUsuarioMaster(slotProps.data.idUsuario, 'S')"></Button>
                  <Button type="button" icon="pi pi-remove" label="Retirar Permissão Master"
                    v-if="slotProps.data.master" @click="saveUsuarioMaster(slotProps.data.idUsuario, 'N')"></Button>
                </template>
              </Column>
              <Column field="usuario.pessoa.numeroDocumentoJuridico" header="CPF">
                <template #filter>
                  <InputText type="text" v-model="filtersModel['usuario.pessoa.numeroDocumentoJuridico']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column field="usuario.loginFormatado" header="Login">
                <template #filter>
                  <InputText type="text" v-model="filtersModel['usuario.loginFormatado']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column field="nomeSocial" header="Nome">
                <template #filter>
                  <InputText type="text" v-model="filtersModel['nomeSocial']" class="p-column-filter"
                    placeholder="Iniciando com" />
                </template>
              </Column>
              <Column headerStyle="width: 18em" bodyStyle="text-align: center" header="Tipo"
                v-if="this.cadastroContador">
                <template #body="slotProps">
                  <span>{{ slotProps.data.idContribuinteVinculo ? 'Contador' : 'Usuário' }}</span>
                </template>
              </Column>
            </DataTable>
          </div>
          <hr />
          <div class="row">
            <div class="col-md-2 mb-2">
              <span class="p-fluid">
                <Button label="Novo" @click="novoUsuario()" icon="pi pi-plus" :disabled="loading"/>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Dialog :visible.sync="showCadastroNovoUsuario" :modal="true" :closable="false">
      <!-- Cabeçalho do modal com título e botão de fechar -->
      <div class="header-container-modal-interno">
        <!-- Título do modal -->
        <h1 class="titulo-header">
          Novo Usuário
          <Button id="icon-close-modals" icon="pi pi-times" class="p-button-rounded p-button-text"
            @click="hideNovoUsuario()" />
        </h1>
        <div class="scrolable-dialog">
          <error-list :erros="erros" />
          <div class="row" v-if="cadastroContador">
            <div class="col-md-3 mb-2">
              <label>Tipo:</label>
              <span class="p-fluid">
                <Dropdown id="tipo" v-model="filtroTipo" :options="filtroTipos" optionLabel="name"
                  placeholder="Selecione um Tipo" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3 mb-2">
              <label>CPF:</label>
              <span class="p-fluid">
                <InputMask @blur="searchUsuarioPorCpf()" v-model="usuarioCadastro.documento" id="cpfUsuario"
                  mask="999.999.999-99" :disabled="blockDadosPessoa" />
              </span>
            </div>
            <div class="col-md-8 mb-2">
              <label>Nome:</label>
              <span class="p-fluid">
                <InputText v-model="usuarioCadastro.nome" type="text" :disabled="blockDadosPessoa" />
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-md-11 mb-2">
              <label>E-mail:</label>
              <span class="p-fluid">
                <InputText v-model="usuarioCadastro.email" type="text" :disabled="editarEmail" />
              </span>
            </div>
          </div>

          <div class="row" v-if="!blockDadosUsuario">
            <div class="col-md-3 mb-2">
              <label>Login:</label>
              <span class="p-fluid">
                <InputText v-model="usuarioCadastro.login" type="text" disabled="true" />
              </span>
            </div>
            <div class="col-md-3 mb-2">
              <label>Senha:</label>
              <span class="p-fluid">
                <InputText v-model="usuarioCadastro.senha" type="password" autocomplete="new-password" />
              </span>
            </div>
            <div class="col-md-3 mb-2">
              <label>Confirme a Senha:</label>
              <span class="p-fluid">
                <InputText v-model="senhaConfirmacao" type="password" autocomplete="new-password" />
              </span>
            </div>
          </div>
        </div>
        <div class="botoes-avancar-voltar" style="margin-top: 20px;">
          <Button @click="salvarNovoUsuario()" label="Salvar" class="p-button-primary mr-2" icon="pi pi-check"
            :disabled="loading" />
          <Button @click="hideNovoUsuario()" type="button" label="Fechar" class="p-button-primary mr-2 p-button-danger"
            icon="pi pi-times" />
        </div>
      </div>
    </Dialog>

    <Dialog header="Aviso" :visible.sync="displayRemove" :style="{ width: '30vw' }" :modal="true">
      Confirma a remoção do Registro?
      <template #footer>
        <Button label="Sim" icon="pi pi-check" @click="remove" />
        <Button label="Não" icon="pi pi-times" @click="close" class="p-button-secondary" />
      </template>
    </Dialog>
    <Dialog header="Permissões" :visible.sync="showPerm" :modal="true" :closable="false" class="test-box"
      :contentStyle="{ overflow: 'visible' }">
      <div class="scrolable-dialog">
        <div class="error-list">
          <Message :closable="false" severity="error" v-if="erros.length">
            <ul class="mt-3">
              <li :key="erro" v-for="erro in erros">{{ erro }}</li>
            </ul>
          </Message>
        </div>
        <div class="row">
          <DataTable :value="perfilList" :paginator="true" :rows="10" :autoLayout="true">
            <Column field="idPagina.menuCompleto" header="Menu"></Column>
            <Column field="habilitarBol" header="Habilitar">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.habilitarBol" :binary="true" />
              </template>
            </Column>
            <Column field="salvarBol" header="Salvar">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.salvarBol" :binary="true" :disabled="!slotProps.data.salvarContr" />
              </template>
            </Column>
            <Column field="alterarBol" header="Alterar">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.alterarBol" :binary="true" :disabled="!slotProps.data.alterarContr" />
              </template>
            </Column>
            <Column field="excluirBol" header="Excluir">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.excluirBol" :binary="true" :disabled="!slotProps.data.excluirContr" />
              </template>
            </Column>
            <Column field="imprimirBol" header="Imprimir">
              <template #body="slotProps">
                <Checkbox v-model="slotProps.data.imprimirBol" :binary="true"
                  :disabled="!slotProps.data.imprimirContr" />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <hr />
      <div class="container">
        <div class="row">
          <div>
            <Button @click="salvarPerm()" label="Salvar" class="p-button-primary mr-2" icon="pi pi-check"
              :disabled="loading" />
            <Button @click="hidePerm()" type="button" label="Fechar" class="p-button-primary mr-2 p-button-danger"
              icon="pi pi-times" />
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>
<script>
import PerfilAcessoUsuarioService from "../services/nfse/perfil.acesso.usuario.service";
import UsuarioAcessoService from "../services/nfse/usuario.acesso.service";
import LoginService from "../services/acesso/login.service";
import UsuarioService from "../services/acesso/usuario.service";
import UsuarioCadastro from "../models/acesso/UsuarioCadastro";
import Util from "../Utils/util";

export default {
  name: "acessoEmpresa",
  data() {
    return {
      showPerm: false,
      displayRemove: false,
      loading: false,
      erros: [],
      currentUser: null,
      usuarioCadastro: new UsuarioCadastro(),
      search: false,
      filtro: "",
      usuarioAcessoList: [],
      filtersModel: {},
      usuarioAcessoId: null,
      idContribuinte: null,
      showCadastroNovoUsuario: false,
      blockDadosPessoa: false,
      blockDadosUsuario: false,
      perfilList: [],
      admin: false,
      senhaConfirmacao: null,
      cadastroContador: false,
      filtroTipo: null,
      filtroTipos: [
        { name: "Usuário", key: "U" },
        { name: "Contador", key: "C" }
      ],
      idClientePortoVelho: null,
      configCadastroContador: null,
      documentoContr: null
    };
  },
  created() {
    this.processando(true);
    this.currentUser = LoginService.currentUserValue;
    this.filtroTipo = this.filtroTipos[0];
    this.cadastroContador = (this.currentUser.configuracao.idBolCadastroContador && this.currentUser.configuracao.idBolCadastroContador === 'S');
    this.pesquisar();
    this.processando(false);
    this.idClientePortoVelho = "8051f762-e8f9-487c-b537-4b2ce582c5e9";
    this.configCadastroContador = this.currentUser.configuracao.idBolCadastroContador;
    this.documentoTomador = this.currentUser.contribuinte.documento;
  },
  methods: {
    isEmailValid: function (email) {
      // eslint-disable-next-line
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    pesquisar() {
      this.search = true;
      this.processando(true);
      UsuarioAcessoService.findAllByContribuinte(
        this.currentUser.usuario.idCliente,
        this.currentUser.contribuinte.idContribuinte
      ).then((ua) => {
        this.usuarioAcessoList = ua.data;
      })
        .then(() => {
          this.search = false;
          this.processando(false);
        });


    },
    confirmRemove(usuarioAcessoId, idContribuinte) {
      this.usuarioAcessoId = usuarioAcessoId;
      this.idContribuinte = idContribuinte;
      this.displayRemove = true;
    },
    close() {
      this.usuarioAcessoId = null;
      this.displayRemove = false;
    },
    remove() {
      UsuarioService.removeUsuarioContribuinte(
        this.currentUser.usuario.idCliente,
        this.usuarioAcessoId,
        this.currentUser.contribuinte.idUsuario,
        this.idContribuinte
      ).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Registro removido com sucesso",
          });
          setTimeout(async () => {
            await this.pesquisar();
            this.displayRemove = false;
          }, 250);
        },
        (error) => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            "Houve um problema ao remover o Registro!"
          );
        }
      );
    },
    saveUsuarioMaster(idUsuario, master) {
      UsuarioService.salvarUsuarioMaster(
        idUsuario,
        master
      ).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Permissão efetuada!",
          });
          setTimeout(async () => {
            await this.pesquisar();
          }, 250);
        },
        (error) => {
          console.log(error);
          this.$root.$emit(
            "alert:error",
            "Houve um problema ao informar Permissão Master para o Registro!"
          );
        }
      );
    },
    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },
    novoUsuario() {
      this.usuarioCadastro = new UsuarioCadastro();
      this.senhaConfirmacao = null;
      this.admin = false;
      this.showCadastroNovoUsuario = true;
      this.blockDadosPessoa = false;
      this.blockDadosUsuario = false;

      this.erros = [];
    },
    hideNovoUsuario() {
      this.showCadastroNovoUsuario = false;
    },
    validar() {
      this.erros = [];
      if (!this.usuarioCadastro.documento || !this.validarDocumento()) {
        this.erros.push("Informe um Documento válido!");
      }
      if (!this.usuarioCadastro.nome) {
        this.erros.push("Informe o Nome!");
      }
      if (!this.usuarioCadastro.email) {
        this.erros.push("Informe o E-Mail!");
      } else if (
        this.usuarioCadastro.email &&
        !this.isEmailValid(this.usuarioCadastro.email)
      ) {
        this.erros.push("Informe um E-Mail válido!");
      }
      if (!this.usuarioCadastro.senha && !this.blockDadosUsuario) {
        this.erros.push("Informe a Senha!");
      } else if (!this.blockDadosUsuario && this.usuarioCadastro.senha != this.senhaConfirmacao) {
        this.erros.push("Senha de Confirmação não confere com a Senha!");
      }

    },
    salvarNovoUsuario() {
      this.processando(true);
      this.validar();
      if (!this.erros.length) {
        this.usuarioCadastro.idConta = this.currentUser.usuario.idConta;
        this.usuarioCadastro.idCliente = this.currentUser.usuario.idCliente;
        this.usuarioCadastro.idAmbiente = this.currentUser.usuario.idAmbiente;
        this.usuarioCadastro.idContribuinte = this.currentUser.contribuinte.idContribuinte;
        this.usuarioCadastro.idUsuarioDoContribuinte = this.currentUser.contribuinte.idUsuario;
        this.usuarioCadastro.idUsuarioPrincipal = this.currentUser.usuario.idUsuario;
        this.usuarioCadastro.master = false;
        this.usuarioCadastro.tipo = (this.filtroTipo && this.filtroTipo.key ? this.filtroTipo.key : null);
        if(this.idClientePortoVelho && this.configCadastroContador === "S" && this.documentoTomador.length > 15){
            for(let i = 0; i < this.usuarioAcessoList.length; i++){
              const usuario = this.usuarioAcessoList[i];
              if(usuario.idContribuinteVinculo && this.usuarioCadastro.tipo === "C"){
                let warnMessage = "Não será possível realizar o cadastro, pois este contribuinte já possui um Contador vinculado."
                this.$root.$emit("alert:warn",warnMessage);
                return;
                
              }
              this.processando(false);
            }
        }
        UsuarioService.save(this.usuarioCadastro).then(
          (data) => {
            console.log(data);
            this.$root.$emit("alert:success", "Registro salvo com sucesso");
            this.pesquisar();
            this.showCadastroNovoUsuario = false;
          },
          (error) => {
            let errorMessage = "Houve um problema ao salvar o Usuário!";
            if (error.response) {
              errorMessage = error.response.data;
            }
            this.$root.$emit("alert:error", errorMessage);
          }
        );
      }
      this.processando(false);
    },
    searchUsuarioPorCpf() {

      const documento = this.usuarioCadastro.documento;

      if (documento && documento != '' && this.validarDocumento()) {
        this.processando(true);
        this.blockDadosPessoa = false;
        this.blockDadosUsuario = false;
        UsuarioService.getUsuarioByCpf(
          documento,
          this.currentUser.usuario.idCliente,
          this.currentUser.usuario.idConta
        )
          .then((data) => {
            console.log(data);
            this.usuarioCadastro = data;
            if (data.idPessoa) {
              this.blockDadosPessoa = true;
            }
            if (data.idUsuario) {
              this.blockDadosUsuario = true;
            }
          })
          .then(() => {
            this.processando(false);
          });
      } else {
        this.processando(true);
      }
    },
    showPermissoes(idUsuario, idContribuinte) {
      this.processando(true);
      this.usuarioAcessoId = idUsuario;
      this.idContribuinte = idContribuinte;
      this.pesquisarPerms();
      this.showPerm = true;
      this.processando(false);
    },
    hidePerm() {
      this.showPerm = false;
    },
    pesquisarPerms() {
      PerfilAcessoUsuarioService.findAllByUsuarioContr(
        this.currentUser.usuario.idCliente,
        this.usuarioAcessoId,
        this.idContribuinte
      ).then(
        (perfil) => {
          this.perfilList = perfil.data;
        },
        (error) => {
          let errorMessage =
            "Houve um problema listar Perfis de Acesso do Usuário!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
          });
        }
      );
      this.search = false;
    },
    salvarPerm() {
      PerfilAcessoUsuarioService.save(
        this.usuarioAcessoId,
        this.idContribuinte,
        this.perfilList
      ).then(
        (data) => {
          console.log(data);
          this.$toast.add({
            severity: "success",
            summary: "Permissões de Acesso salvas com sucesso",
          });
        },
        (error) => {
          let errorMessage =
            "Houve um problema ao salvar as Permissões de Acesso!";
          if (error.response) {
            errorMessage = error.response.data;
          }
          this.$toast.add({
            severity: "error",
            summary: errorMessage,
          });
        }
      );
    },

    validarDocumento() {
      var validar = false;
      if (!this.usuarioCadastro.documento || this.usuarioCadastro.documento === '') {
        return false;
      }
      validar = Util.validarCPFCNPJ(this.usuarioCadastro.documento);

      if (!validar) {
        this.$root.$emit("alert:error", "CPF/CNPJ inválido!");
      }
      return validar;
    },
  },
  computed:{
    editarEmail:{
      get(){
        if(this.currentUser.configuracao.idBolEditarEmailUsuarioRes === "S"){
          console.log("1 - idBolEditarEmailUsuarioRes ", this.currentUser.configuracao.idBolEditarEmailUsuarioRes);
          return false;
        }else{
          console.log("2 - idBolEditarEmailUsuarioRes ", this.currentUser.configuracao.idBolEditarEmailUsuarioRes);
          console.log("solicitarEmail ", this.usuarioCadastro.solicitarEmail);
          return !this.usuarioCadastro.solicitarEmail;
        }
      }
    }
  }
};
</script>

<style src="../assets/css/acessoEmpresa.css"></style>
